module.exports = __webpack_public_path__ + "static/media/mkc-food-products.10e976ed.png";